import LogoImage from 'components/subscribe/property/LogoImage';
import TitleDescription from 'components/subscribe/property/TitleDescription';

function PageHeader({
  branding,
}: {
  branding: {
    logoImageURL: string;
    titleCopy: string;
    descriptionCopy: string;
  };
}) {
  return (
    <>
      <LogoImage logoImageURL={branding.logoImageURL} />
      <TitleDescription branding={branding} />
    </>
  );
}

export default PageHeader;
